import React from 'react'
import { Radio } from 'react-bootstrap'

const R = (props) => {
  const {label, checked, onChange, style} = props
  return (
    <Radio checked={checked} inline onChange={onChange}>
      <span style={{fontWeight:'bold', ...style}}>{label}</span>
    </Radio>
  )
}

export default R



// WEBPACK FOOTER //
// ./src/lib/themes/lingk/Radio.js